(function () {
  'use strict';

  // Single global <dialog> (rendered once, inside the header pill component)
  // that any number of trigger buttons on the page can open -- the header
  // pill trigger (desktop) and the drawer row trigger (mobile) both carry
  // [data-bruku-discord-open] and point at this same dialog, so there is
  // only ever one modal instance in the DOM no matter how many entry
  // points exist. Native <dialog> gives us ESC-to-close and focus trapping
  // for free. We only need to wire: open (delegated, covers any current or
  // future trigger), explicit close controls, and click-outside (a click
  // that lands on the ::backdrop reports the dialog itself as event.target
  // since the backdrop has no box of its own to receive it).
  function setupDiscordModal() {
    var dialog = document.querySelector('[data-bruku-discord-dialog]');
    if (!dialog || dialog.__brukuDiscordBound) return;
    dialog.__brukuDiscordBound = true;

    // Two-frame handshake so the fade+scale transition in CSS actually has
    // something to animate from: the dialog opens instantly (browser
    // requirement), then we add .is-visible on the next frame so the
    // transition kicks in. Closing reverses the same way, waiting for the
    // transition to finish before calling dialog.close().
    var CLOSE_TRANSITION_MS = 220;

    function open() {
      if (typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else {
        dialog.setAttribute('open', '');
      }
      document.documentElement.classList.add('bruku-discord-open');
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          dialog.classList.add('is-visible');
        });
      });
    }

    function close() {
      if (!dialog.open && !dialog.hasAttribute('open')) return;
      dialog.classList.remove('is-visible');
      document.documentElement.classList.remove('bruku-discord-open');
      window.setTimeout(function () {
        if (typeof dialog.close === 'function' && dialog.open) {
          dialog.close();
        } else {
          dialog.removeAttribute('open');
        }
      }, CLOSE_TRANSITION_MS);
    }

    // Delegated listener: catches every [data-bruku-discord-open] trigger
    // on the page (header pill, drawer row, any future entry point) without
    // needing to know about them individually or re-bind if the drawer
    // content is re-rendered.
    document.addEventListener('click', function (event) {
      var opener = event.target.closest('[data-bruku-discord-open]');
      if (opener) open();
    });

    dialog.querySelectorAll('[data-bruku-discord-close]').forEach(function (btn) {
      btn.addEventListener('click', close);
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) close();
    });

    // Covers ESC (native cancel/close, bypasses our close()) so state never
    // gets stuck if the dialog closes some way other than our own buttons.
    dialog.addEventListener('close', function () {
      dialog.classList.remove('is-visible');
      document.documentElement.classList.remove('bruku-discord-open');
    });

    // "Unirme al Discord" opens the invite in a new tab via its own
    // href/target attributes (no JS needed for that part); we just also
    // close the modal behind it for a clean state on return.
    var joinLink = dialog.querySelector('[data-bruku-discord-join]');
    if (joinLink) {
      joinLink.addEventListener('click', function () {
        window.setTimeout(close, 150);
      });
    }
  }

  function init() {
    setupDiscordModal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
